import { useEffect, useState } from "react";
import type { ApiListing } from "@/data/mockData";

export type HomeCityItem = {
  cidade: string;
  estado?: string;
  uf?: string;
  label?: string;
};

export type HomeData = {
  cidades: string[];
  items: HomeCityItem[];
  servicos: { id: number; nome: string }[];
  recomendados: ApiListing[];
  carousel: any[];
};

export function useHomeData() {
  const [data, setData] = useState<HomeData | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    Promise.all([
      fetch("/api/home", { headers: { Accept: "application/json" } }),
      fetch("/api/buscar/cidades", { headers: { Accept: "application/json" } }),
    ])
      .then(async ([homeRes, cidadesRes]) => {
        if (!homeRes.ok) throw new Error(`HOME HTTP ${homeRes.status}`);
        if (!cidadesRes.ok) throw new Error(`CIDADES HTTP ${cidadesRes.status}`);

        const homeJson = await homeRes.json();
        const cidadesJson = await cidadesRes.json();

        const recomendados: ApiListing[] =
          homeJson.recomendados ??
          homeJson.listings ??
          homeJson.resultados ??
          [];

        const items: HomeCityItem[] = cidadesJson.items ?? [];

        setData({
          cidades: items
            .map((item) => item.label || item.cidade)
            .filter(Boolean),
          items,
          servicos: homeJson.servicos ?? [],
          recomendados,
          carousel: homeJson.carousel ?? [],
        });
      })
      .catch((e) => setErr(e?.message || String(e)));
  }, []);

  return { data, err };
}